// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "d0b3ff29fe0d484b8b92" + ".chunk.js";
};